import i18n from '../i18n/i18n';

/**
 * The text to show for an error caught on the Books catalog pages (Authors, Books, Book Bundles,
 * Warehouses). Messages the page threw itself are already in the admin's language and pass
 * through. The browser's own errors (fetch failing while offline, a reply that isn't JSON) are in
 * English whatever the language: English shows them as before, Spanish says what happened.
 */
export const catalogErrorText = (err, fallback = '') => {
  const message = (err && err.message) || '';
  if (!message) return fallback;
  if (err instanceof TypeError && /fetch|network|load failed/i.test(message)) {
    return i18n.t('browser.network', { ns: 'serverBookCatalog', message });
  }
  if (err instanceof SyntaxError) {
    return i18n.t('browser.badResponse', { ns: 'serverBookCatalog', message });
  }
  return message;
};

export default catalogErrorText;
